/**
 * Created by Mark on 24/11/2016.
 */

import BaseStore from './base-store.js';
import Constants from '../constants/assignments.js';
import HomeworkConstants from '../constants/homework.js';
import {FormattedDate}  from 'react-intl';
import React  from 'react';
import Student from '../classes/student.js';
import Date from "../classes/date.js";

class Assignment{
    constructor(ietf , uid , name , classes , students , setDTS , dueDTS , tests , totalComplete , totalIncomplete , vocab){
        this.uid = uid;
        this.name = name;
        this.language = <img className="avatar-img" src={"img/flags/"+ietf+".png"} alt=""/>
       // this.languageName = <Image />
        this.profileLink = this.getLink();
        this.totalStudents = students.length || 0;
        this.setDTSObject = new Date(setDTS);
        this.dueDTSObject = new Date(dueDTS);
        this.totalComplete = totalComplete;
        this.totalIncomplete = totalIncomplete;
        this.totalOverdue    = this.dueDTS < (new Date()) ? totalIncomplete : 0,
        this.tests = tests;
        this.setDTS = (new Date()).format(setDTS);
        this.dueDTS = (new Date()).format(dueDTS);
        this.rawSet = setDTS;
        this.rawDue = dueDTS;
        this.vocab = vocab;

        this.students = students.map(function(student){
            return this.constructStudent(student);
        }.bind(this));

    }

    constructStudent(student){
        var studentObject = new Student(student.uid , student.name , student.username , student.password , student.classes);
            studentObject.hasCompleted  = student.isComplete;
            studentObject.scores  = student.scores;
        return studentObject;
    }

    getLink(){
        return {link:'assignment/overview/'+this.uid ,  value:this.name};
    }
}

class AssignmentStore extends BaseStore {

    constructor() {
        super();
        this.subscribe(() => this._registerToActions.bind(this));
        this.allHomework = [];
        this.assignmentJSON = {};
    }

    _processAssignments(assignments){
        var response = [];
        for(var idx = 0 ; idx < assignments.length; idx++){
            response.push(new Assignment(assignments[idx].ietf , assignments[idx].uid , assignments[idx].name , assignments[idx].classes , assignments[idx].students , assignments[idx].set_dts , assignments[idx].due_dts , null , assignments[idx].totalComplete , assignments[idx].totalIncomplete ))
        }

        return response;
    }

    _registerToActions(action) {

        switch(action.actionType)
        {
            case HomeworkConstants.ON_VIEWABLE_HOMEWORK_FETCH:
                this.viewableHomework = action.response;
                this.emit('ON_GET_HOMEWORK_FEATURES');
                break;
            case Constants.UPDATE_ALL_HOMEWORK:

                this.allHomework = this._processAssignments(action.response)
                this.emitChange();
                break;
            case Constants.UPDATE_ASSIGNMENT:
                this.assignmentJSON[action.response.uid] = new Assignment(action.response.ietf ,  action.response.uid , action.response.name , action.response.classes , action.response.students , action.response.set_dts , action.response.due_dts , action.response.games ,   action.response.totalComplete   , action.response.totalIncomplete , action.response.vocab);
                this.emit('GET_HOMEWORK_DETAIL');
                break;

        }
    }

    getHomework(assignmentID){
        console.log(this.assignmentJSON);
        return this.assignmentJSON[assignmentID];
    }

}

export default new AssignmentStore();


// WEBPACK FOOTER //
// ./src/store/assignment-store.js